import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'fc-skeleton-list',
  template: `
    @for (_ of [].constructor(count); track $index) {
      <div class="list-loader">
        <fc-skeleton
          [width]="width"
          [height]="height"
          animation="wave"
          [shape]="shape"
        ></fc-skeleton>
        <div class="list-loader-side flex justify-center">
          <fc-skeleton
            width="100%"
            height="16px"
            animation="wave"
            shape="text"
          ></fc-skeleton>
          <fc-skeleton
            width="50%"
            height="12px"
            animation="wave"
            shape="text"
          ></fc-skeleton>
        </div>
      </div>
    }
  `,
  styles: [
    `
      :host {
        width: 100%;
      }

      .list-loader {
        display: flex;
        padding: 16px 16px 0;

        &:last-of-type {
          padding-bottom: 16px;
        }

        .list-loader-side {
          display: flex;
          flex-direction: column;
          gap: 12px;
          margin-left: 12px;
          flex-grow: 2;
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SkeletonListComponent {
  @Input() shape: 'rectangle' | 'circle' | 'text' = 'circle';
  @Input() count = 10;
  @Input() width = '50px';
  @Input() height = '50px';

  @Input() set autoCount(state: boolean) {
    if (state) {
      const parentHeight = window.innerHeight - 80;
      const height = Number(this.height.slice(0, -2)) + 16;
      this.count = Math.floor(parentHeight / height);
    }
  }
}
